import TemplateEditHeaderComponent from "~/components/pages/supervisor/templates/edit/header";

export default function TemplateEditHeaderPage() {
  return <TemplateEditHeaderComponent />;
}
